<template>
  <top-navigation
    previous-route="settings"
    :title="$t('settings.push.title')"
  />

  <div class="mx-auto px-4 pt-24 pb-8">
    <information-text
      v-if="
        (isRunningInFlutterApp &&
          (!notificationsStore.hasMobileNotificationPermission ||
            !notificationsStore.hasFcmToken)) ||
        (!isRunningInFlutterApp &&
          !status.updatedDeviceToken &&
          !status.fetchingDeviceToken)
      "
      color="orange"
      :information="$t('settings.push.getting_push_token_failed')"
    />
    <information-text
      v-if="
        isRunningInFlutterApp &&
        notificationsStore.hasMobileNotificationPermission &&
        notificationsStore.hasFcmToken
      "
      color="green"
      :information="$t('settings.push.your_device_can_receive_notifications')"
    />
    <information-text
      v-if="!isRunningInFlutterApp && status.updatedDeviceToken"
      color="green"
      :information="$t('settings.push.your_device_can_receive_notifications')"
    />

    <!-- Event Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("settings.push.event_notifications") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.event_create"
        :label="$t('settings.push.event_created')"
        :disabled="status.saving"
      />
      <toggle-switch
        v-model="notificationSettings.event_comment"
        :label="$t('settings.push.event_comment')"
        :disabled="status.saving"
      />
    </div>

    <!-- Quote Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("settings.push.quote_notifications") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.quote_create"
        :label="$t('settings.push.quote_notifications_created')"
        :disabled="status.saving"
      />
      <toggle-switch
        v-model="notificationSettings.quote_comment"
        :label="$t('settings.push.quote_notifications_comment')"
        :disabled="status.saving"
      />
    </div>

    <!-- Dilemma Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("pages.games.dilemmas_title", "Dilemmas") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.dilemma_create"
        :label="$t('pages.dilemmas.create_title', 'New dilemma created')"
        :disabled="status.saving"
      />
      <toggle-switch
        v-model="notificationSettings.dilemma_comment"
        :label="$t('settings.push.dilemma_comment', 'New comment on dilemma')"
        :disabled="status.saving"
      />
    </div>

    <!-- Photo Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("settings.push.photo_notifications") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.photo_create"
        :label="$t('settings.push.photo_created')"
        :disabled="status.saving"
      />
      <toggle-switch
        v-model="notificationSettings.photo_comment"
        :label="$t('settings.push.photo_comment')"
        :disabled="status.saving"
      />
    </div>

    <!-- Shorts Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("pages.shorts.title", "Shorts") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.short_create"
        :label="$t('settings.push.short_created', 'New short posted')"
        :disabled="status.saving"
      />
      <toggle-switch
        v-model="notificationSettings.short_comment"
        :label="$t('settings.push.short_comment', 'New comment on short')"
        :disabled="status.saving"
      />
    </div>

    <!-- Group Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("settings.push.group_notifications") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.group_member_joined"
        :label="$t('settings.push.group_member_added')"
        :disabled="status.saving"
      />
    </div>

    <!-- Anniversary Notifications -->
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div
          class="w-full border-t-2 border-black-dark dark:border-slate-600"
        ></div>
      </div>
      <div class="relative flex justify-center">
        <span
          class="bg-white px-4 text-sm font-medium text-gray-600 dark:bg-kekkle-dark dark:text-slate-400"
        >
          {{ $t("settings.push.anniversary_notifications") }}
        </span>
      </div>
    </div>
    <div class="">
      <toggle-switch
        v-model="notificationSettings.quote_yearly_anniversary"
        :label="$t('settings.push.quote_yearly_anniversary')"
        :disabled="status.saving"
      />
      <toggle-switch
        v-model="notificationSettings.photo_yearly_anniversary"
        :label="$t('settings.push.photo_yearly_anniversary')"
        :disabled="status.saving"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { reactive, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import TopNavigation from "@/components/TopNavigation.vue";
import InformationText from "@/components/InformationText.vue";
import ToggleSwitch from "@/components/ui/ToggleSwitch.vue";
import * as Sentry from "@sentry/vue";
import {
  updateDoc,
  getDoc,
  doc,
  type FirestoreError,
} from "firebase/firestore";
import { usersCollection } from "@/helpers/firebase/firebase";
import { setErrorToast, setSuccessToast } from "@/helpers/notifications/toast";
import { useAuthStore } from "@/stores/modules/auth/auth";
import { useUserStore } from "@/stores/modules/user/user";
import { handleFirestoreException } from "@/helpers/exceptions/handler";
import { askFcmTokenFlutter } from "@/helpers/flutter/features/notifications";
import { isRunningInFlutter } from "@/helpers/flutter/capabilities";
import { useNotificationsStore } from "@/stores/modules/notifications/notifications";
import {
  groupPushDocumentReference,
  upsertUserPushSettingsForGroup,
} from "@/helpers/firestore/GroupPushSettingsService";
import { PushSettingsOptions } from "@kekkle/shared/enums/push-settings-options";

const { t } = useI18n();
const authStore = useAuthStore();
const userStore = useUserStore();
const notificationsStore = useNotificationsStore();

type NotificationSettings = Record<PushSettingsOptions, boolean>;

const status = reactive({
  fetchingSettings: false,
  updatingSettings: false,
  fetchingDeviceToken: false,
  updatedDeviceToken: false,
  saving: false,
});

const notificationSettings = reactive<NotificationSettings>({
  [PushSettingsOptions.PHOTO_CREATE]: true,
  [PushSettingsOptions.PHOTO_COMMENT]: true,
  [PushSettingsOptions.EVENT_CREATE]: true,
  [PushSettingsOptions.QUOTE_CREATE]: true,
  [PushSettingsOptions.GROUP_MEMBER_JOINED]: true,
  [PushSettingsOptions.QUOTE_COMMENT]: true,
  [PushSettingsOptions.EVENT_COMMENT]: true,
  [PushSettingsOptions.QUOTE_YEARLY_ANNIVERSARY]: true,
  [PushSettingsOptions.PHOTO_YEARLY_ANNIVERSARY]: true,
  [PushSettingsOptions.DILEMMA_CREATE]: true,
  [PushSettingsOptions.DILEMMA_COMMENT]: true,
  [PushSettingsOptions.SHORT_CREATE]: true,
  [PushSettingsOptions.SHORT_COMMENT]: true,
});

const isRunningInFlutterApp = isRunningInFlutter();
let saveTimeout: ReturnType<typeof setTimeout> | null = null;

async function fetchNotifications(): Promise<void> {
  try {
    if (!userStore.activeGroup) {
      return;
    }

    const pushTokensDoc = await getDoc(
      groupPushDocumentReference(userStore.activeGroup),
    );

    if (!pushTokensDoc.exists()) {
      return;
    }

    const data = pushTokensDoc.data();
    if (data?.settings?.[authStore.authUuid!]) {
      Object.assign(notificationSettings, data.settings[authStore.authUuid!]);
    }
  } catch (e) {
    handleFirestoreException({ e: e as FirestoreError });
    setErrorToast({
      message: t("global.toast.error_fetching_push_settings"),
    });
  } finally {
    status.fetchingSettings = false;
  }
}

async function pushDeviceToken(): Promise<void> {
  try {
    await Notification.requestPermission();
  } catch (e) {
    Sentry.captureException(e);
  }

  try {
    status.fetchingDeviceToken = true;
    await notificationsStore.registerMessageToken();
    status.updatedDeviceToken = true;
  } catch (e) {
    Sentry.captureMessage(JSON.stringify(e));
    Sentry.captureException(e);
  }
  status.fetchingDeviceToken = false;
}

async function save(): Promise<void> {
  try {
    status.saving = true;
    status.updatingSettings = true;
    const userDoc = doc(usersCollection, authStore.authUuid!);
    await updateDoc(userDoc, {
      push_settings: notificationSettings,
    });

    const groups = userStore.userData?.groups || [];
    for (const groupId of groups) {
      try {
        await upsertUserPushSettingsForGroup({
          groupId,
          userId: authStore.authUuid!,
          settings: { ...notificationSettings },
          language:
            userStore.userData?.language ||
            localStorage.getItem("locale") ||
            undefined,
        });
      } catch (e) {
        const message = handleFirestoreException({ e: e as FirestoreError });
        setErrorToast({ message });
      }
    }

    setSuccessToast({
      message: t("global.toast.push_settings_saved"),
    });
  } catch (e) {
    const message = handleFirestoreException({ e: e as FirestoreError });
    setErrorToast({ message });
  } finally {
    status.updatingSettings = false;
    status.saving = false;
  }
}

onMounted(async () => {
  window.scrollTo({ top: 0, left: 0 });

  if (isRunningInFlutterApp) {
    askFcmTokenFlutter();
    notificationsStore.setHasFetched(true);
  } else {
    pushDeviceToken();
  }

  // Wait for initial data to load before setting up watcher
  await fetchNotifications();

  // Now watch for changes and auto-save with debounce
  watch(
    notificationSettings,
    () => {
      // Clear existing timeout
      if (saveTimeout) {
        clearTimeout(saveTimeout);
      }

      // Debounce save by 500ms
      saveTimeout = setTimeout(() => {
        save();
      }, 500);
    },
    { deep: true },
  );
});
</script>
